export default function MiniDashboard({ stats, testid }) {
  return (
    <div
      data-testid={testid || "mini-dashboard"}
      className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8"
    >
      {stats.map((s, i) => {
        const Icon = s.icon;
        const tint = s.tint || "forest";
        const tints = {
          forest: "bg-forest-soft text-forest",
          accent: "bg-terracotta/10 text-terracotta",
          warn: "bg-yellow-50 text-yellow-700",
          info: "bg-blue-50 text-blue-700",
          danger: "bg-red-50 text-red-700",
        };
        return (
          <div
            key={i}
            data-testid={s.testid}
            className="card-surface p-4 md:p-5"
          >
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0">
                <div className="font-figtree text-xs md:text-sm text-ink-soft truncate">{s.label}</div>
                <div className="font-outfit font-bold text-xl md:text-2xl text-ink mt-1 truncate">{s.value}</div>
                {s.sub && <div className="text-xs text-ink-soft font-figtree mt-1 truncate">{s.sub}</div>}
              </div>
              {Icon && (
                <div className={`h-9 w-9 rounded-xl grid place-items-center flex-shrink-0 ${tints[tint]}`}>
                  <Icon className="h-4 w-4" strokeWidth={1.75} />
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
